<template>
    <div>
        <button
            class="btn btn-primary btn-sm"
            data-toggle="modal"
            :data-target="targetInfoModalId"
            data-placement="top"
            :title="$t('edit')"
            >
            <i class="glyphicon glyphicon-edit"></i>
        </button>
        <button
            class="btn btn-danger btn-sm"
            data-toggle="modal"
            :data-target="targetModalId"
            data-placement="top"
            :title="$t('trash')"
            >
            <i class="glyphicon glyphicon-trash"></i>
        </button>

        <div class="modal modal-danger fade" :id="modalId" style="display: none;">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span></button>
                        <h4 class="modal-title">Danger</h4>
                    </div>
                    <div class="modal-body">
                        <p>{{$i18n.messages[$i18n.locale].deleteMessage}}</p>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-outline"
                            data-dismiss="modal"
                            @click="$_admin_app_action_remove(data.appId)"
                        >
                            {{$i18n.messages[$i18n.locale].submit}}
                        </button>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>


        <div class="modal modal-info fade" :id="infoModalId" style="display: none;">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span></button>
                        <h4 class="modal-title">{{$i18n.messages[$i18n.locale].editApp}}</h4>
                    </div>

                    <div class="modal-body" style="background-color: white !important; color: black !important;">
                        <form class="ui form addAppForm">
                            <div class="row" v-bind:class="{ 'has-error2': $v.newApp.keyName.$invalid }">
                                <div class="col-md-3 text-left">
                                    <label style="color: red;">*</label>
                                    {{$i18n.messages[$i18n.locale].keyName}} :
                                </div>
                                <div class="col-md-8">
                                    <input
                                        v-model="newApp.keyName"
                                        class="form-control"
                                        placeholder="key"
                                        type="text">
                                </div>
                            </div>
                            <div class="row" v-bind:class="{ 'has-error2': $v.newApp.platform.$invalid }">
                                <div class="col-md-3 text-left">
                                    <label style="color: red;">*</label>
                                    {{$i18n.messages[$i18n.locale].platform}} :
                                </div>
                                <div class="col-md-8">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <input
                                                id="platform1"
                                                v-model="newApp.platform"
                                                value="android"
                                                type="radio" />
                                            <label for="platform1">android</label>
                                        </div>
                                        <div class="col-md-3">
                                            <input
                                                id="platform2"
                                                v-model="newApp.platform"
                                                value="ios"
                                                type="radio" />
                                            <label for="platform2">ios</label>
                                        </div>
                                    </div>
                                    
                                    
                                    
                                </div>
                            </div>
                            <div class="row" v-bind:class="{ 'has-error2': $v.newApp.publishSecret.$invalid }">
                                <div class="col-md-3 text-left">
                                    <label style="color: red;">*</label>
                                    {{$i18n.messages[$i18n.locale].publishSecret}} :
                                </div>
                                <div class="col-md-8">
                                    <input
                                        v-model="newApp.publishSecret"
                                        class="form-control"
                                        placeholder="key"
                                        type="text">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3 text-left">{{$i18n.messages[$i18n.locale].testSecret}} :</div>
                                <div class="col-md-8">
                                    <input
                                        v-model="newApp.testSecret"
                                        class="form-control"
                                        placeholder="key"
                                        type="text">
                                </div>
                            </div>
                            <div class="row" v-bind:class="{ 'has-error2': $v.newApp.packageName.$invalid }">
                                <div class="col-md-3 text-left">
                                    <label style="color: red;">*</label>
                                    {{$i18n.messages[$i18n.locale].package}} :
                                </div>
                                <div class="col-md-8">
                                    <input
                                        v-model="newApp.packageName"
                                        class="form-control"
                                        placeholder="key"
                                        type="text">
                                </div>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer" style="background-color: white !important; color: black !important;">
                        <button
                            type="button"
                            class="btn btn-outline"
                            @click="$_admin_app_edit_checkEditApp()"
                            style="color: black; border: 1px solid #3c8dbc;"
                        >
                            {{$i18n.messages[$i18n.locale].submit}}
                        </button>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->

            <div v-bind:class="{overlay: true, hidden: !loading}">
                <i class="fa fa-refresh fa-spin"></i>
            </div>
        </div>

    </div>
</template>
<script>
    import moment from 'moment'
    import api from '../../api'
    import config from '../../config'
    import { required } from 'vuelidate/lib/validators'
    export default {
        props: {
            data: Object
        },
        data () {
            return {
                modalId: '',
                targetModalId: '',
                infoModalId: '',
                targetInfoModalId: '',
                loading: false,
                newApp: {
                    packageName: '',
                    keyName: '',
                    platform: '',
                    publishSecret: '',
                    testSecret: '',
                    appId: '',
                    appKey: '',
                    expire: ''
                }
            }
        },
        validations () {
            let data = {
                newApp: {
                    packageName: {
                        required
                    },
                    keyName: {
                        required
                    },
                    platform: {
                        required
                    },
                    publishSecret: {
                        required
                    }
                }
            }
            return data
        },
        mounted () {
            this.modalId = 'modal-danger' + this.data.appId
            this.targetModalId = '#modal-danger' + this.data.appId
            this.infoModalId = 'modal-info' + this.data.appId
            this.targetInfoModalId = '#modal-info' + this.data.appId
            this.$_admin_app_edit_findApp(this.data.appId)
        },
        methods: {
            $_admin_app_action_remove (id) {
                const path = config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiApp
                const headers = {'authorization': this.$store.state.token}
                const params = { ids: id }
                return api.request('delete', path, {}, params, headers)
                    .then(response => {
                        this.$parent.$parent.$children[0].refresh()
                    })
            },
            $_admin_app_edit_findApp (appId) {
                const path = config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiApp + '/' + appId
                const headers = {'authorization': this.$store.state.token}
                console.log('get ' + path)
                return api.request('get', path, {}, {}, headers)
                    .then(response => {
                        const data = response.data.data.payload[0]
                        this.newApp.packageName = data.package
                        this.newApp.keyName = data.keyName
                        this.newApp.platform = data.platform
                        this.newApp.publishSecret = data.publishSecret
                        this.newApp.testSecret = data.testSecret
                        this.newApp.appId = data.appId
                        this.newApp.appKey = data.appKey
                        this.newApp.expire = data.expire
                        this.newApp.expire = moment(this.expire * 1000).format('YYYY-MM-DD HH:mm:ss')
                    })
            },
            $_admin_app_edit_checkEditApp () {
                const {keyName, platform, publishSecret, testSecret} = this.newApp
                this.$_admin_app_edit_toggleLoading()
                const headers = {'authorization': this.$store.state.token}
                const path = config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiApp + '/' + this.data.appId
                /* eslint-disable object-property-newline */
                let body = {keyName, platform, publishSecret, package: this.newApp.packageName}
                if (testSecret) {
                    body.testSecret = testSecret
                }
                api.request('put', path, body, {}, headers)
                    .then(response => {
                        const data = response.data
                        /* Checking if error object was returned from the server */
                        if (data.error) {
                            const errorName = data.error.name
                            if (errorName) {
                                this.response = errorName
                            } else {
                                this.response = data.error
                            }
                            return
                        }

                        /* Setting app in the state and caching record to the localStorage */
                        if (response.data.status.code === 0) {
                            this.insertSuccess = true
                            this.$_admin_app_edit_toggleLoading()
                            this.$parent.$parent.$children[0].refresh()
                            window.$(this.targetInfoModalId).modal('hide')
                        }
                    })
                    .catch(error => {
                        this.$store.commit('TOGGLE_LOADING')
                        console.log(error)

                        this.response = 'Server appears to be offline'
                        this.$_admin_app_edit_toggleLoading()
                    })
            },
            $_admin_app_edit_toggleLoading () {
                this.loading = !this.loading
            }
        }
    }
</script>

<style scoped>
    .addAppForm > .row {
        margin-top: 15px;
    }

    .addAppForm > .has-error3 input {
        background-color: #f8c9c8;
        border-color: #f18482;
        border-width: 2px;
    }

    #modal-info .modal-body, #modal-info .modal-footer {
        background-color: white !important;
        color: black !important;
    }
    #modal-info .btn-outline {
        color: black;
        border: 1px solid #3c8dbc;
    }
    .modal-info .form-control {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// ListAppAction2.vue?5b99762e